export enum AuthActionTypes {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  SET_ERROR = "SET_ERROR",
  SET_FETCHING_CURRENT_USER = "SET_FETCHING_CURRENT_USER",
}
